import ApiClient from "@/lib/api-client"
import { collectionItemKey } from "@/lib/utils"

export default {
  namespaced: true,

  state: {
    purchasedProducts: [],
    programs: [],
    events: [],
    recentPages: [],
    pages: [],
    sharedItems: [],
    upcomingPages: [],
    bookmarkedItems: [],
    savedPagination: null,
    hasFormSubmissions: false
  },

  mutations: {
    setContent(
      state,
      {
        purchased_products,
        programs,
        recentPages,
        events,
        pages,
        shared_items,
        upcoming_pages,
        bookmarked_items,
        saved_pagination,
        has_form_submissions
      }
    ) {
      if (purchased_products) state.purchasedProducts = purchased_products

      if (programs) state.programs = programs

      if (recentPages) state.recentPages = recentPages

      if (events) state.events = events

      if (pages) state.pages = pages

      if (shared_items) state.sharedItems = shared_items

      if (upcoming_pages) state.upcomingPages = upcoming_pages

      if (bookmarked_items) state.bookmarkedItems = bookmarked_items
      state.savedPagination = saved_pagination || null
      state.hasFormSubmissions = has_form_submissions
    },

    appendBookmarkedItems(state, { items, pagination }) {
      const seen = new Set(state.bookmarkedItems.map(collectionItemKey))
      const fresh = items.filter(item => !seen.has(collectionItemKey(item)))

      state.bookmarkedItems = [...state.bookmarkedItems, ...fresh]
      state.savedPagination = pagination || state.savedPagination
    }
  },

  actions: {
    fetchMyContent({ commit }) {
      return ApiClient.get("/my-content").then(res => {
        commit("setContent", res.data)
      })
    }
  }
}
